import { watchEffect } from 'vue';
import { storeToRefs } from 'pinia';
import { usePagesStore } from '@/store/pagesStore';
import { useCategoriesStore } from '@/store/categoriesStore';
import { useProductsStore } from '@/store/productsStore';
import { checkAndFixImageFallback } from '@/helpers/images/imageFallback';

/**
 * Composable that watches all images from relevant stores.
 * Calls helper to validate/fix image sources.
 */
export function useImageFallbackWatcher() {
    const pagesStore = usePagesStore();
    const productsStore = useProductsStore();
    const categoriesStore = useCategoriesStore();

    const { getAllImages: pageImages } = storeToRefs(pagesStore);
    const { getAllImages: categoryImages } = storeToRefs(categoriesStore);
    const { getAllImages: productImages } = storeToRefs(productsStore);

    watchEffect(() => {
        const allImages = [...pageImages.value, ...productImages.value, ...categoryImages.value];

        for (const img of allImages) {
            checkAndFixImageFallback(img);
        }
    });
}
